// Bootstrap JS
// @devnote comment this line if you plan to
// use the CDN version of boostrap js
import 'bootstrap';

import { watchScroll } from './lib/scroll';
import { silenceModalsOnDismiss } from './lib/video';
import { inInViewAnimations } from './lib/animate';

/**
 * Benchmarking
 */
const timeStart = window.performance.now();

/**
 * Configure fonts for this project
 */

document.addEventListener('DOMContentLoaded', () => {

	// Do stuff...
	watchScroll();
	silenceModalsOnDismiss();
	inInViewAnimations();

	/**
	 * Benchmarking reporting
	 */
	const timeEnd = window.performance.now();
	console.info(
		`Execution time: ${timeEnd - timeStart}ms after DOMContentLoaded.`
	);
});

$(document).ready(function() {
	$('.insights-single .content__wrap p:first-child').html(function (i, t) {
		var words = t.split(/\s+/);
		return '<span class="text-bold">' + words.slice(0,3).join(" ") + '</span> ' + words.slice(3).join(" ");
	});


	$('button.expand-nav').on('click', function() {
		var submenu = $(this).next('.sub-menu-wrapper')
		$(this).addClass('rotate');
		submenu.addClass('display');
		setTimeout(function() {
			submenu.addClass('expanded');
		}, 100);
	});

	$('.sub-menu-wrapper button.close-sub').on('click', function() {
		$('button.expand-nav').removeClass('rotate');
		$('.sub-menu-wrapper').removeClass('expanded');
		setTimeout(function() {
			$('.sub-menu-wrapper').removeClass('display');
		}, 400);
	});

	
});
